import React from 'react';
import {connect} from 'react-redux'

import DefaultTemplateContainer from '../../../containers/DefaultTemplateContainer'
import {
    loginAction
} from '../../../actions'
import LoginForm from './LoginForm'


class ViewBox extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <DefaultTemplateContainer
                title='學生登入'
                htmlBody={<LoginForm onSubmit={this.onSubmit}/>}
                // flash_msg={this.state.flash_msg}
            />
        )
    }

    onSubmit = (value) => {
        value.toJS()
        this.props.loginAction(value.get('login'), value.get('password'))
    }
}


const mapStateToProps = (state) => {
    return {
        // studentList: state.getIn(['studentList', 'data']),
    }
}
const mapDispatchToProps = (dispatch) => ({
    loginAction: (login_id, password) => (
        dispatch(loginAction(dispatch, login_id, password))
    )
})
export default connect(mapStateToProps, mapDispatchToProps)(ViewBox)


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DeviseContainer/LoginContainer/View.jsx